import { useEffect, useState } from "react";
import { getEnv } from "@tarojs/taro";

export const useTaroEnv = () => {
  const [taroEnv, setTaroEnv] = useState("");
  useEffect(() => {
    setTaroEnv(getEnv());
  }, []);

  return taroEnv;
};

export const useAsyncEffect = async (fn, deps) => {
  useEffect(() => {
    fn().catch(err => {
      console.log(err);
    });
  }, [deps]);
};
